import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcLogout = ({ size, color }) => {
  return (
    <Icon
      className="ic-menu-dots material-icons tw-block tw-flex tw-items-center tw-justify-center"
      size={size}
      color={color}
    >
      logout
    </Icon>
  )
}

IcLogout.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
}

export default IcLogout
